// extracted by mini-css-extract-plugin
export default {"reviewPageContent":"LongTestimonials_reviewPageContent__vhb9M","longReviewCard":"LongTestimonials_longReviewCard__7-J+3"};